export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "markupCounter.worker.2c38b8a5130fddbda499.worker.js");
}
